export interface IConfirmation {
    title: string;
    message: string;
    subMessage: string;
    messageAligned?: 'left' | 'right' | 'center';
    isMessageBold?: boolean;
    isSubMessageBold?: boolean;
    showIcon?: boolean;
    iconClass?: string;
}
export function confirmation({
    title,
    message,
    subMessage,
    iconClass,
    showIcon,
    isMessageBold,
    messageAligned = 'center',
    isSubMessageBold
}: IConfirmation) {
    let icon = '',
        confirmationMessage = '',
        confirmationSubMessage = '',
        messageAlignedClassName = '';

    switch (messageAligned) {
        case 'left':
            messageAlignedClassName = 'text-left';
            break;
        case 'right':
            messageAlignedClassName = 'text-right';
    }

    if (showIcon && iconClass) {
        icon = `<span class="confirmation__icon">
                    <i class="nx nx-${iconClass}"></i>
                </span>`;
    }

    if (message) {
        confirmationMessage = isMessageBold
            ? `<div class="confirmation__message--main ${messageAlignedClassName}">
                                        <b>${message}</b>
                                    </div>`
            : `<div class="confirmation__message--main ${messageAlignedClassName}">
                                    ${message}
                                </div>`;
    }

    if (subMessage) {
        confirmationSubMessage = isSubMessageBold
            ? `<div class="confirmation__message--sec">
                                        <b>${subMessage}</b>
                                    </div>`
            : `<div class="confirmation__message--sec">
                                        ${subMessage}
                                    </div>`;
    }

    return `<div class="modal-header">
                <div class="modal-title">${title}</div>
            </div>
            <div class="modal-body confirmation">
                <div class="confirmation__message">
                    ${icon}
                    ${confirmationMessage}
                    ${confirmationSubMessage}
                </div>
            </div>`;
}
